
































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { IFilter, ISorter } from "@/models/tables";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import { TransactionStatus, TransactionTypes } from "@/data/constants";
import { FilterOperators, FilterTypes } from "@/data/table";
import Context from "@/mixins/context";
import { TransactionFilters } from "@/data/filters/transactions";
import { TransactionSorters } from "@/data/sorters/transactions";
import i18n from "@/i18n";
import { IBrand } from "@/models/brands";
import { IPaymentLog } from "@/models/paymentLog";

@Component({
  computed: {
    ...mapState({
      brandId: (state: any) => state.auth.admin.brandId,
      brands: (state: IState) => state.auth.admin.brands
    }),
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class TransactionsTable extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Props
  @Prop({ required: false, default: null })
  public clientId!: string;

  @Prop({
    default: () => [
      TransactionTypes.AGREEMENT_AUTHORIZE,
      TransactionTypes.AGREEMENT_CANCEL,
      TransactionTypes.AGREEMENT_CAPTURE,
      TransactionTypes.AGREEMENT_EXECUTE,
      TransactionTypes.AUTHORIZE_DIRECT,
      TransactionTypes.AUTHORIZE_EXECUTE,
      TransactionTypes.AUTHORIZE_LINK,
      TransactionTypes.BANK_TRANSFER,
      TransactionTypes.CAPTURE,
      TransactionTypes.MANUAL_PAYMENT,
      TransactionTypes.REFUND,
      TransactionTypes.SALE_DIRECT,
      TransactionTypes.SALE_EXECUTE,
      TransactionTypes.SALE_LINK,
      TransactionTypes.SUBSCRIBE_LINK,
      TransactionTypes.WALLET,
      TransactionTypes.WALLET_REFUND_OUT
    ]
  })
  public readonly transactionTypes!: TransactionTypes[];

  @Prop({ default: () => [] })
  public readonly statuses!: TransactionStatus[];

  // Data
  public dataModule: string = DataModules.PAYMENTS;
  public brandId!: IBrand["id"];
  public brands!: any[];
  public isMultibrand!: boolean;
  public filters: IFilter[] = TransactionFilters(this.statuses);
  public sorters: ISorter[] = TransactionSorters();
  public loading = true;

  public created() {
    this.apiProps = {
      with: "client,client.image,gateway,brand,invoice,client_payment_details"
    };

    if (this.clientId === null) {
      this.filters.splice(
        0,
        0,
        {
          key: "client.firstname",
          label: i18n.t("_.client_firstname"),
          type: FilterTypes.STRING,
          operator: FilterOperators.EQUAL
        },
        {
          key: "client.lastname",
          label: i18n.t("_.client_lastname"),
          type: FilterTypes.STRING,
          operator: FilterOperators.EQUAL
        },
        {
          key: "client.email",
          label: i18n.t("_.client_email"),
          type: FilterTypes.STRING,
          operator: FilterOperators.EQUAL
        }
      );
    }
    this.getData();
  }

  public get allAvailableFilters() {
    return this.$_.cloneDeep(this.filters);
  }

  public getFilterForClient() {
    return this.clientId ? { "filter[client_id]": this.clientId } : {};
  }

  public getFilterStatuses() {
    return !this.$_.isEmpty(this.statuses)
      ? {
          "filter[status]": this.statuses.map(i => this.$_.toUpper(i)).join(",")
        }
      : {};
  }

  public getFilterForTransactionTypes() {
    return {
      "filter[transaction_type]": this.transactionTypes.join(",")
    };
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(
      {
        params: {
          ...this.getFilterStatuses(),
          ...this.getFilterForClient(),
          ...this.getFilterForTransactionTypes()
        }
      },
      params
    );
  }

  public get resultsIncludeRecentRefunds() {
    return !!this.$_.filter(this.table.data, (log: IPaymentLog) => {
      const logCreatedAt = this.$moment.utc(log.created_at).toDate();
      const sevenDaysAgo = this.$moment()
        .subtract(7, "days")
        .startOf("day")
        .toDate();
      return (
        [TransactionTypes.REFUND].includes(log.transaction_type) &&
        logCreatedAt > sevenDaysAgo
      );
    }).length;
  }
}
